export enum PillLevel {
  Default = 'default', // gray
  Information = 'information', // orange
  Success = 'success', // green
  Warning = 'warning', // yellow
  Error = 'error', // red
}
